import React from "react";

const MainContainer = ({ children }) => <div id="main">{children}</div>;

export default MainContainer;
